import {
  React,
  Heading,
  Subtitle,
  Text,
  Button,
  // Link,
  Row,
  Col
} from "mondrian-react";
import { handleMesMask } from "utils/handleMesMask";
import { logger } from "utils/logger";
import useIsTotem from "hooks/useIsTotem";
import QRCode from "react-qr-code";
// import Countdown from "react-countdown";
import { useEffect, useState } from "react";
import { stepPix } from "./variables";
import { isMobile } from "react-device-detect";

//Style
import "./styles.scss";
import Banks from "components/Banks";
import { reportGA4 } from "utils/pushDataLayer";

// const timeLimit = 360000;

const PaymentPix = ({ fatura, goBack, setCodeBarAlert }) => {
  const splittedDate = fatura.paymentDueDate.split("-");
  const formattedDate = `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`;
  const formattedLabelDate = `${handleMesMask(splittedDate[1])} • ${
    splittedDate[0]
  }`;
  const [pix, setPix] = useState("");
  // const [time, setTime] = useState(Date.now() + timeLimit);
  // const styleConter = isMobile ? "35%" : "58%";
  const isTotem = useIsTotem();

  useEffect(() => {
    //chamada pix
    setPix(fatura.paymentCode);
    // setTime(Date.now() + timeLimit);
    // move();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fatura]);

  // function move() {
  //   var i = 0;
  //   if (i === 0) {
  //     i = 1;
  //     var elem = document.getElementById("myBar");
  //     var width = timeLimit / 1000;
  //     var widthTotal = 100 / (timeLimit / 1000);
  //     var second = 60;
  //     var id = setInterval(frame, 1000);
  //     function frame() {
  //       if (second === 0 && width > 0) {
  //         second = 60;
  //       }
  //       if (width <= 0) {
  //         goBack();
  //         clearInterval(id);
  //         i = 0;
  //       } else {
  //         width--;
  //         second--;
  //         elem.style.width = width * widthTotal + "%";
  //       }
  //     }
  //   }
  // }

  return (
    <>
      <Row>
        <Col xs={12} lg={10} className="mdn-Offset-lg-2">
          <Subtitle xs className="textTitular">
            {formattedLabelDate}
          </Subtitle>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={7} className="mdn-Offset-lg-2 mdn-u-flex mdn-u-flex-xs-column mdn-u-flex-lg-row mdn-u-justifyContent-lg-between mdn-u-alignItems-lg-center">
            <Heading xl className="textMoney">
            R$ {parseFloat(fatura.billAmount).toFixed(2).replace(".", ",")}
            </Heading>
            <Text body className="textDue">
              Vencimento: {formattedDate}
            </Text>
            <div className="mdn-Tag mdn-Tag-category mdn-Tag--feedback mdn-u-marginTop--xxs mdn-u-marginBottom--xxs">
              <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm"></i>
              <p className="mdn-Text textAberto">Aberto</p>
            </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={8} className="mdn-Offset-lg-2">
          <Heading lg className="textTitle mdn-u-marginBottom--sm">
            Pagar com Pix
          </Heading>
          <div className="divBar">
            <p className="mdn-CopyContainer-content-toCopy mdn-Heading mdn-Heading--xxs divTextContador mdn-u-marginTop--sm">
              {pix}
            </p>
            <QRCode size={isMobile ? 100 : 256} value={pix} className="qrCodePix"/>
            {!isTotem &&
              <Button
              className="CopyPixButton"
                onClick={() => {
                  logger({ name: "CopyPixButton" });
                  reportGA4({customTitle: 'pagar_com_pix:copiar_codigo_pix'})
                  navigator.clipboard.writeText(pix);
                  setCodeBarAlert(true);
                }}
              >
                Copiar código Pix
              </Button>
            }
          </div>
          <Heading xs className="textTitular">
            Siga essas instruções para o pagamento
          </Heading>
          {stepPix.map((o, i) => (
            <div
              key={i.toString() + o.step}
              className="mdn-Topic mdn-Topic--horizontal mdn-Topic--number mcm-Circle"
            >
              <div>
                <p className="mdn-Topic-description stepTextCircle">{o.step}</p>
              </div>
              <p className="mdn-Topic-description mcm-TitleGray">{o.text}</p>
            </div>
          ))}
          <div className="mdn-Tag mdn-Tag--feedback mdn-Tag--inverse alertText">
            <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm alertColor"></i>
            <p className="alertColor">
              Atenção! A forma de pagamento selecionada valerá para um único
              pagamento e não será recorrente para as outras faturas ou transações.{" "}
            </p>
          </div>
          {!isTotem &&
            <div>
              <Banks localTag="pagar_com_pix" />
              <div className="mdn-Tag mdn-Tag--feedback mdn-Tag--inverse divInfo">
                <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm alertColor"></i>
                <p className="alertColor">
                  O seu pagamento pode ser confirmado em 5h se for feito através dos
                  bancos conveniados (Itaú, Santander, Bradesco, Caixa e Safra). Para os
                  demais bancos a confirmação será feita em até 3 dias. Lembre-se de
                  pagar seu boleto até a data de vencimento original de sua fatura para
                  evitar juros e multa.
                </p>
              </div>
            </div>
          }
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="mdn-u-marginTop--sm mdn-u-marginBottom--sm">
          <Button secondary href={"#"} onClick={() => {
            goBack()
            reportGA4({customTitle: 'pagar_com_pix:voltar'})
          }}>Voltar</Button>
        </Col>
      </Row>
    </>
  );
};

export default PaymentPix;
